import { useProgrameazaTargetareDescoperire } from "@/hooks/api/mutate/useProgrameazaTargetareDescoperire";
import { useProgrameazaTargetareImbogatire } from "@/hooks/api/mutate/useProgrameazaTargetareImbogatire";
import { useRuleazaTargetareDescoperire } from "@/hooks/api/mutate/useRuleazaTargetareDescoperire";
import { useGetTargetareContacteStats } from "@/hooks/api/query/useGetTargetareContacteStats";
import { useToast } from "@/hooks/use-toast";
import { formatNumar } from "@/utils/targetareFormatting";
import { DescoperirePanel } from "../components/DescoperirePanel";
import { ImportContacteDialog } from "../components/ImportContacteDialog";

const LOT_IMBOGATIRE = 1200;

export default function ContacteTargetare() {
  const { toast } = useToast();
  const contacteStats = useGetTargetareContacteStats();
  const programare = useProgrameazaTargetareDescoperire();
  const lotDescoperire = useRuleazaTargetareDescoperire();
  const imbogatire = useProgrameazaTargetareImbogatire();

  const programeazaDescoperirea = () => {
    programare.mutate(
      { tiers: ["A", "B", "C"] },
      {
        onSuccess: (raspuns) => {
          toast({
            title: "Descoperire programată",
            description: `${formatNumar(raspuns.data.programate)} firme în coadă; extragerea din liste rulează în fundal, iar site-urile sunt procesate automat, câte un lot la 20 de secunde.`,
          });
        },
        onError: (e) =>
          toast({
            title: "Programarea a eșuat",
            description: e.message,
            variant: "destructive",
          }),
      }
    );
  };

  const ruleazaLot = () => {
    lotDescoperire.mutate(
      { lot: 5 },
      {
        onSuccess: (raspuns) => {
          const gasite = raspuns.data.rezultate.reduce(
            (s, r) => s + r.emailuri,
            0
          );
          toast({
            title: "Lot procesat",
            description: `${raspuns.data.procesate} firme verificate, ${gasite} emailuri găsite.`,
          });
        },
        onError: (e) =>
          toast({
            title: "Lotul a eșuat",
            description: e.message,
            variant: "destructive",
          }),
      }
    );
  };

  const programeazaImbogatirea = () =>
    imbogatire.mutate(
      { reia: false, limita: LOT_IMBOGATIRE },
      {
        onSuccess: (raspuns) =>
          toast({
            title: "Îmbogățire Termene programată",
            description: `${formatNumar(raspuns.data.noi)} firme noi (cele mai mari primele), ${formatNumar(raspuns.data.reluate)} reluate; ${formatNumar(raspuns.data.in_coada)} de procesat din ${formatNumar(raspuns.data.total)} programate. Rulează în fundal, câte 5 la 30 de secunde.`,
          }),
        onError: (e) =>
          toast({
            title: "Programarea a eșuat",
            description: e.message,
            variant: "destructive",
          }),
      }
    );

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="space-y-1">
          <h2 className="text-xl font-heading font-semibold">
            Colectarea contactelor
          </h2>
          <p className="max-w-3xl text-sm text-muted-foreground">
            Surse: listele oficiale, site-urile firmelor verificate prin CUI,
            Termene.ro (date de contact, administratori, asociați, persoane de
            contact), importuri CSV și adăugări manuale. Fiecare valoare
            păstrează sursa din care a fost preluată.
          </p>
        </div>
        <ImportContacteDialog />
      </div>

      <DescoperirePanel
        stats={contacteStats.data}
        isLoading={contacteStats.isLoading}
        programare={{
          inCurs: programare.isPending,
          onClick: programeazaDescoperirea,
        }}
        lot={{ inCurs: lotDescoperire.isPending, onClick: ruleazaLot }}
        termene={{
          inCurs: imbogatire.isPending,
          onClick: programeazaImbogatirea,
        }}
      />
    </div>
  );
}
